import { combineReducers } from "redux";
import ThemeReducer from "./../Reducers/Theme";

const rootReducer = combineReducers({
  ThemeReducer,
});

export default rootReducer;
